/** "COPYRIGHT © year RUSH" and "Powered By: InfinixIT", used under the welcome screen and the signed-in pages */
export function AppCredits({ className = "" }: { className?: string }) {
  return (
    <div className={`flex justify-between items-center text-gray-400 font-medium ${className}`}>
      <span>COPYRIGHT © {new Date().getFullYear()} RUSH</span>

      <a
        href="https://infynixit.dev/"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-1.5"
      >
        <span>Powered By:</span>
        <img src="/iit-logo-dark.png" alt="" className="h-4 w-auto" />
      </a>
    </div>
  );
}
